import {useEffect, useState} from "react";
import {PermitService} from "permit/service";
import {useErrors} from "base/error/provider";
import {useViolationsSummaryTable} from "violation/data";
import {SectionCard} from "base/ui/section/components";
import {SimpleTable} from "base/table/components";
import {NoDataContainer, Spinner} from "base/shared/components";

const ApprovedPermitViolationsSection = ({permitId}) => {
    const {tableColumns} = useViolationsSummaryTable();
    const [violations, setViolations] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const {handleErrors} = useErrors();

    useEffect(() => {
        setIsLoading(true);
        PermitService.getViolations(permitId)
            .then(response => {
                setViolations(response);
            })
            .catch(error => handleErrors(error))
            .finally(() => setIsLoading(false));
    }, [permitId]);

    return (
        <SectionCard title="Infracções">
            {isLoading ? (
                <Spinner />
            ) : violations.length ? (
                <SimpleTable dataRows={violations} tableColumns={tableColumns} />
            ) : (
                <NoDataContainer text="Esta autorização não tem infracções." />
            )}
        </SectionCard>
    );
};

export default ApprovedPermitViolationsSection;
